<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Device Renewal" title="Deactivated Devices" />
 
		<div class="container-fluid">
			
			<div class="card">
				<div class="card-body">

                    <div class="col-md-12 project-list filter-sort">
						<div class="row">
							<div class="col-md-6 d-flex">
								<label class="d-flex listing-length"><span>Show</span>
									<select class="form-select" v-model="listing_length" @change="fetchdeactivatedDevices()">
										<option value="20">20</option>
										<option value="30">30</option>
										<option value="50">50</option>
										<option value="100">100</option>
										<option value="200">200</option>
									</select>
									<span>entries</span>
								</label>
							</div>
							<div class="col-md-3 mb-2">
								
							</div>
							<div class="col-md-3">
								<input type="text" class="form-control" placeholder="IMEI" v-model="keyword" @keyup="fetchdeactivatedDevices()"/>
							</div>
						</div>
					</div>
								
					<div class="table-responsive product-table">
						<table class="display" id="basic-1" >
							<thead>
								<tr align="center">
									<th>IMEI & ICCID</th>
									<th>Expired On</th>
                                    <th>Deactiavted On</th>
                                    <th>Vehicle</th>
									<th>Dealer</th>
                                    <th>Action</th>
									
								</tr>
							</thead>

							<tbody>
								<tr v-for="(device) in deactivated_devices" :key="device.id" align="center">
                                    <td>{{ device.imei }} <br>
										{{ device.iccid }}
									</td>
									<td>{{ $filters.formatDateTime(device.expired_on)}}</td>
                                    <td>{{ $filters.formatDate(device.deactivated_on) }}</td>
                                    <td>{{ device.vehicle_no }}</td>
                                    <td>{{ device.dealer }}<br>
										{{ device.dealer_contact }}
									</td>
                                    <td>
										<button class="btn btn-warning btn-sm mt-2 me-2 mb-2" type="button" data-original-title="test" v-if="device.recharge_status != 1" @click="rechargeModal(device)">Recharge</button>
										<router-link :to="{ name: 'update_vehicle_data',params:{imei:device.imei} }" class="btn btn-primary btn-sm me-2" v-if="!device.vehicle_no">Add Vehicle</router-link><br>
										<a class="btn btn-success btn-sm mt-2 me-2 mb-2" @click="renewDevice(device)" v-if="device.renewal_status == 2 && device.recharge_status == 1">Renew</a>
									</td>
								</tr>

							</tbody>

						</table>
					</div>

					<!----pagination starts --->
					<caption v-if="Boolean(deactivated_devices.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
					<nav aria-label="Page navigation" class="mt-2 float-end">
						<ul class="pagination">
							<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
								<a class="page-link" href="#" @click.prevent="fetchdeactivatedDevices(page.url + '&limit=' + listing_length + '&keyword=' + keyword)" tabindex="-1">
									<span v-if="index == 0">Prev</span>
									<span v-else-if="index == pagination.length - 1">Next</span>
									<span v-else>{{ page.label }}</span>
								</a>
							</li>
						</ul>
					</nav>  
					<!----pagination ends --->
                </div>

			</div>
		</div>

		<DynamicModal :title="modal_title">
			<template #body>
				<form @submit.prevent="updateRecharge" enctype="multipart/form-data" @hidden="clearForm()">

					<div class="col-md-12 form-group mb-2">
						<label class="control-label">Renewal Type<span class="text-danger">*</span></label>
						<select class="form-select" v-model="device.renewal_type">
							<option value="">--select--</option>
							<option value="1">Normal</option>
							<option value="2">SIM Change</option>
							<option value="3">Replacement</option>
						</select>
					</div>

					<div class="col-md-12 form-group mb-2">
						<label class="control-label">Year Of Expiry<span class="text-danger">*</span></label>
						<select class="form-select" v-model="device.yr_of_expiry">
							<option value="">--select--</option>
							<option value="1">1 Year</option>
							<option value="2">2 Year</option>
						</select>
					</div>

					<div class="col-md-12 form-group mb-2">
						<label class="control-label">Amount<span class="text-danger">*</span></label>
						<input class="form-control" type="text" placeholder="Enter Amount" v-model="device.amount"/>
					</div>

					<div class="col-md-12 form-group mb-2">
						<label class="control-label">Payment Status<span class="text-danger">*</span></label>
						<select class="form-select" v-model="device.payment_status">
							<option value="">--select--</option>
							<option value="1">Received</option>
							<option value="2">Not Received</option>
						</select>
					</div>

					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" >{{ button_title }}</button>
						<button class="btn btn-light" type="button" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>

   </div>
</template>


<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "Renewed Devices",
		components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},
		
		data() {

			return {
				modal_title: "Update Recharge",
				button_title: "Save",

				pagination: {},
				
				keyword: "",
				listing_length: 20,
				token: "",
				deactivated_devices: [],
                type: "",
                payment_status: "",

				device: 
				{
					renewal_id: "",
					renewal_type: "",
					yr_of_expiry:"",
					amount:"",
					payment_status: "",
				},

				renew_status: {
					id: "",
				},

				pagination: {},

				complete_status: {
					id: "",
				},
				
				errors: {},
				
			};
		},
		mounted() {},

		created() {
			this.fetchdeactivatedDevices();
		},

		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

			fetchdeactivatedDevices(page_url = null) {
				this.getToken();
				let url = "/staffs/deactivatedDevices?limit=" + this.listing_length  + "&keyword=" + this.keyword ;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.deactivated_devices = responseData.deactivated_devices.data;
						this.pagination = responseData.deactivated_devices.links;
						this.from = responseData.deactivated_devices.from;
						this.to = responseData.deactivated_devices.to;
						this.total = responseData.deactivated_devices.total;
						
					})
					.catch((err) => console.log(err));
			},

			deactivateDevice(device) {
				this.deactivate = false;
				this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to deactivate this device?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
					}
				});
			},

			renewDevice(device) {
				this.deactivate = false;
				this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to renew this device?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						this.renew_status.id = device.id;
						this.deviceRenew();
					}
				});
			},

			deviceRenew() {
				const config = {
					headers: {
						Authorization: "Bearer " + this.token,
					},
				};
				this.$axios
					.get("/staffs/renewDevice?device_id=" + this.renew_status.id , config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.fetchdeactivatedDevices(this.active_page_url);
					})
					.catch((error) => {
						if (error.response) {
							if (error.response.data.message) {
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},


			openModal() {
				this.showModal();
			},

			closeModal() {
				this.hideModal();
			},

			rechargeModal(device) {
                this.errors = {};
				this.device.id =device.renewal_id;
                this.device.yr_of_expiry = device.yr_of_expiry;
				this.device.payment_status = device.payment_status;
				this.device.renewal_type = device.renewal_type;
				this.modal_title = "Update Recharge";
				this.button_title = "Save";
				this.showModal();
            },

			closeModal() {
				this.hideModal();
				this.clearForm();
			},

			clearForm() {
				this.edit = false;
				this.modal_title = "Update Recharge";
				this.button_title = "Save";
				this.errors = {};
			},

			async updateRecharge() {
				this.loading = true;
				this.errors = {};

				// Validation
				if (!this.device.renewal_type) {
					this.errors.renewal_type = "Renewal type is required";
				}
				if (!this.device.yr_of_expiry) {
					this.errors.year_of_expiry = "Year of expiry is required";
				}
				if (!this.device.amount) {
					this.errors.amount = "Amount is required";
				}
				if (!this.device.payment_status) {
					this.errors.payment_status = "Payment status is required";
				}

				if (Object.keys(this.errors).length > 0) {
					this.loading = false;
					return;
				}

				try {
					const response = await this.$axios.post(
						"/staffs/updateRechargeStatus",
						{
							device_id: this.device.id,
							renewal_type: this.device.renewal_type,
							year_of_expiry: this.device.yr_of_expiry,
							amount: this.device.amount,
							payment_status: this.device.payment_status,
						},
						{
							headers: {
								Authorization: `Bearer ${this.token}`,
							},
						}
					);

					if (response.data.status === true || response.data.status === "true") {
						this.$swal("Success", response.data.message || "Device recharge updated successfully", "success")
							.then(() => {
								this.closeModal();
								this.fetchdeactivatedDevices();
							});
					} else {
						this.$swal("Error", response.data.message || "Failed to update recharge", "error");
					}

				} catch (error) {
					console.error("API Error:", error);
					this.$swal("Error", "Something went wrong while updating recharge", "error");
				} finally {
					this.loading = false;
				}
		},

		},
	};
</script>
